module.exports = function(posts) {
	"use strict";
  posts
  .controller('tagEditController', tagEditController)
	tagEditController.$inject = ["$scope","$state","getDataService","refreshtokenService","$attrs","putDataService","alertService","$rootScope","serverError","checkArray","postDataService","offlineError"]
	
  function tagEditController($scope,$state,getDataService,refreshtokenService,$attrs, putDataService, alertService,$rootScope,serverError, checkArray, postDataService,offlineError) {
    var vmte = this;
    $scope.parent = $scope.$eval($attrs.parent);
    vmte.tagId = $scope.parent.tagId;
    vmte.loadCategory= false;
    vmte.mergeTagsArr = [];
    if($rootScope.role_id == 'administrator' || $rootScope.role_id == 'superadmin') {
      vmte.superPermisions = true;
    }
    vmte.mergeTags = function() {
      $rootScope.hasLoaded = false;
      var mergeTagsIds = {
        'ids': vmte.mergeTagsArr
      }
      var postFunction = function() {
        postDataService.save({
          param1:'tags', 
          param2: 'merge',
          param3: vmte.tag._id
        },mergeTagsIds).$promise.then(function(data){
          $rootScope.hasLoaded = true;
          alertService('success','Success ', data.message, 2000);
          vmte.mergeTagsArr = []
        }, function(error){
          if(!window.navigator.onLine) {
            offlineError()
            $rootScope.hasLoaded = true;
            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
            return
          }
          if(error.status == 401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
            function(answer) {
              if(answer==200) {
                postFunction();
              }
              // do something
            },
            function(error) {
              // report something
            },
            function(progress) {
             // report progress
            });
          }else if(error.status ==502) {
            serverError()
          } else {
            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
          }
          $rootScope.hasLoaded = true;
        });
      }
      postFunction();
    }
    var addNewTagFunction = function(data) {
      vmte.newTagRequired = false;
      if(!checkArray.contains.call(vmte.mergeTagsArr,data.tagId)) {
        vmte.mergeTagsArr.push(data.tagId);
        vmte.searchtagfocus = null;
        vmte.existTag = false;
      } else {
        vmte.existTag = true;
      }
    }
    $scope.$on('select-tag', function(event,data) {
      addNewTagFunction(data.selectedTagObj)
    });
    vmte.addNewTag = function() {
      return
    }
    vmte.removeFromTagsList = function(index) {
      vmte.mergeTagsArr.splice(index, 1);
    }
    $rootScope.closeEditTag = function() {
      $scope.parent.tagEdit = false;
      vmte.tag = null;
      $state.transitionTo('app.tags', {id: null}, {
        location: true,
        inherit: true,
        relative: $state.$current,
        notify: false
      });
    }
    var getTagFunction = function() {
      $rootScope.hasLoaded = false;
      getDataService.get({param1:'tags', param2: vmte.tagId}).$promise.then(function(data){
        $rootScope.hasLoaded = true;
        vmte.tag = data;
      }, function(error){
        if(!window.navigator.onLine) {
          offlineError()
          $rootScope.hasLoaded = true;
          return
        }
        if(error.status ==401) {
          var promise = refreshtokenService.getAccessToken();
          promise.then(
            function(answer) {
              if(answer==200) {
                getTagFunction();
              }
            },
            function(error) {
            },
            function(progress) {
             // report progress
          });
        } else if(error.status ==502) {
          serverError()
        } else {
          $scope.parent.tagEdit = false;
          $state.transitionTo('app.tags', {id: null}, {
            location: true,
            inherit: true,
            relative: $state.$current,
            notify: false
          });
        }
        $rootScope.hasLoaded = true;
      }); 
    }
    getTagFunction();
    if(!window.navigator.onLine) {
      offlineError('refresh')
      return
    }
  }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/postsModule/tag-edit/js/tagEditController.js
// module id = 569
// module chunks = 0